module.exports = __webpack_public_path__ + "static/media/contestLogo.7b05f080.jpg";